import { initialStatisticalAnalysisHomeState, StatisticalAnalysisHomeState } from '@/modules/statistical-analysis-module/components/statistical-analysis-home/statistical-analysis-home.models'
import { Vue, Component } from 'vue-property-decorator'

@Component
export default class StatisticalAnalysisHome extends Vue {
    state: StatisticalAnalysisHomeState[]
    constructor() {
        super()
        this.state = initialStatisticalAnalysisHomeState()
    }

    get visibleModules(): StatisticalAnalysisHomeState[] {
        return this.state.filter((module: StatisticalAnalysisHomeState) => module.active)
    }

    goTo(section: string) {
        this.$router.push({ name: section })
    }
}
